import PropTypes from 'prop-types';

export const QrCodeDefaultProps = {
  isOpen: false,
  onScanQrCode: () => {},
};

export const QrCodePropTypes = {
  isOpen: PropTypes.bool,
  onScanQrCode: PropTypes.func,
};
